var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"v-breadcrumbs",class:[_vm.classes]},_vm._l((_vm.items),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"item":item}},[_vm._v(" "+_vm._s(item.text)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }